<template>
    <EditDialog :show="show" title="选择位置" width="1200px">
        <Container>
            <div class="ly-content-line condition-line">
                <div class="block">
                    <label> 定位城市： </label>
                    <el-input size="mini" v-model="cityName" style="width: 400px" />
                    <el-button type="primary" size="mini" class="search-button" style="margin-left: 10px" @click="changeCity"> 定位 </el-button>
                </div>
                <div class="block">
                    当前位置：
                    <span> lng:{{ currentPoint.lng }}， </span>
                    <span> lat:{{ currentPoint.lat }} </span>
                </div>
            </div>
            <div class="map-container">
                <div class="ly-content map" ref="dvMap"></div>
                <div class="map-sprite"></div>
            </div>
        </Container>
        <template #button>
            <div class="dialog-footer">
                <el-button size="mini" @click="onSave" style="margin-right: 30px" type="primary">保存</el-button>
                <el-button size="mini" @click="onCancel">取消</el-button>
            </div>
        </template>
    </EditDialog>
</template>
<script>
export default {
    name: "MapSelectLocation",
    props: {
        show: {
            type: Boolean,
        },
        point: { type: Object },
    },
    data() {
        return {
            cityName: "",
            currentPoint: null,
            marker: null,
            map: null,
            isInit: false,
            cacheKey: "___map___location___cache",
        };
    },
    created() {},
    mounted() {
        if (this.point) {
            try {
                let p = new window.BMapGL.Point(this.point.lng, this.point.lat);
                this.currentPoint = p;
            } catch (e) {
                console.log(e);
                this.currentPoint = null;
            }
        }
        if (this.currentPoint == null) {
            let p = new window.BMapGL.Point(116.41338729034514, 39.910923647957596);
            let data = localStorage.getItem(this.cacheKey);
            if (data && data.indexOf("|") > 0) {
                try {
                    let p1 = new window.BMapGL.Point(parseFloat(data.split("|")[0]), parseFloat(data.split("|")[1]));
                    p = p1;
                } catch (e) {
                    console.log(e);
                }
            }
            this.currentPoint = p;
        }
        this.$nextTick(() => {
            this.map = new window.BMapGL.Map(this.$refs.dvMap);
            this.map.centerAndZoom(this.currentPoint, 19);
            this.map.enableScrollWheelZoom();
            this.map.enableDragging();
            this.map.setHeading(64.5);
            this.map.setTilt(73);
            this.isInit = false;
            this.map.addEventListener("moveend", this.changedLocation);
            this.map.addEventListener("dragend", this.changedLocation);
            this.map.addEventListener("zoomend", this.changedLocation);
            this.map.addEventListener("touchend", this.changedLocation);
            //this.map.addEventListener("click", this.mapClicked);
        });
    },
    methods: {
        changedLocation() {
            this.currentPoint = this.map.getCenter();
        },
        changeCity() {
            this.map.centerAndZoom(this.cityName, 14);
        },
        onSave() {
            if (!this.currentPoint) {
                this.$warn("请选择位置！");
                return;
            }
            localStorage.setItem(this.cacheKey, this.currentPoint.lng + "|" + this.currentPoint.lat);
            this.$emit("save", this.currentPoint);
        },
        onCancel() {
            this.$emit("close");
        },
    },
};
</script>
<style scoped>
.map-container {
    width: 100%;
    height: 600px;
    padding: 10px;
    box-sizing: border-box;
    position: relative;
    margin: 0;
}
.map-container .map {
    width: 100%;
    height: 100%;
    z-index: 100;
    padding: 0;
    margin: 0;
}
.map-sprite {
    width: 20px;
    height: 25px;
    background: url(../styles/imgs/map-sprite.png) no-repeat center;
    position: absolute;
    top: calc(50% - 25px);
    left: calc(50% - 10px);
    z-index: 1000;
}
.map-sprite-text {
    height: 25px;
    position: absolute;
    top: calc(50% - 25px);
    left: calc(50% + 20px);
    z-index: 1000;
}
</style>
